// @ts-nocheck
/* eslint-disable func-names */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/named */
import { takeLatest, spawn, put } from 'redux-saga/effects';

import apiRequest, { apiSuccess } from 'utils/api';
import { truthty } from 'utils/functions';
import { appActions } from 'commons/reducer';
import { delay } from 'redux-saga/effects';
import { USERS } from '../reducer';

function* getStateFromApi() {
  yield takeLatest(USERS.GET_STATE_FROM_API, function* (action) {
    const response = yield apiRequest('api/v1/users/users', { method: 'get' });

    if (response && response.users) {
      const transformedPayload = {
        objects: {
          users: {},
        },
      };

      response.users.forEach((user) => {
        transformedPayload.objects.users[user.id] = user;
      });
      yield put(apiSuccess(USERS.GET_STATE_FROM_API_SUCCESS, transformedPayload));
    }
  });
}

function* createUser() {
  yield takeLatest(USERS.CREATE_USER, function* (action) {
    try {
      const response = yield apiRequest('api/v1/users', {
        method: 'post',
        body: JSON.stringify(action.formData),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response && response.error) {
        let errorMessage = 'Error al crear usuario';
        if (response.errorMsg) {
          try {
            const parsedError = JSON.parse(response.errorMsg);
            errorMessage = parsedError.error || parsedError.details || errorMessage;
          } catch (e) {
            errorMessage = response.errorMsg;
          }
        }

        yield put(apiSuccess(USERS.CREATE_USER_FAIL, { error: errorMessage }));
        yield put(appActions.setError(errorMessage));
        return;
      }

      if (response && response.user && response.role) {
        const userKeys = Object.keys(response.user);
        const roleKeys = Object.keys(response.role);

        if (userKeys.length === 0 || roleKeys.length === 0) {
          yield put(
            apiSuccess(USERS.CREATE_USER_FAIL, { error: 'Respuesta incompleta del servidor' }),
          );
          return;
        }

        const userId = userKeys[0];
        const roleId = roleKeys[0];
        const newUser = response.user[userId];
        const newRole = response.role[roleId];

        const userWithRole = {
          ...newUser,
          role: newRole,
        };

        const transformedPayload = {
          objects: {
            users: {
              [newUser.id]: userWithRole,
            },
            roles: {
              [newRole.id]: newRole,
            },
          },
          user: userWithRole,
          role: newRole,
          message: response.message,
          ssoData: response.ssoData,
        };

        yield put(apiSuccess(USERS.CREATE_USER_SUCCESS, transformedPayload));
        yield put(appActions.setSuccess('Usuario creado exitosamente'));
      } else {
        yield put(
          apiSuccess(USERS.CREATE_USER_FAIL, { error: 'Respuesta incompleta del servidor' }),
        );
      }
    } catch (error) {
      let errorMessage = 'Error al crear usuario';
      if (error.response && error.response.data) {
        errorMessage = error.response.data.error || error.response.data.message || errorMessage;
      } else if (error.message) {
        errorMessage = error.message;
      }
      yield put(apiSuccess(USERS.CREATE_USER_FAIL, { error: errorMessage }));
      yield put(appActions.setError(errorMessage));
    }
  });
}

function* updateUser() {
  yield takeLatest(USERS.UPDATE_USER, function* (action) {
    try {
      const { userId, formData } = action;

      const response = yield apiRequest(`api/v1/users/${userId}`, {
        method: 'PUT',
        body: JSON.stringify(formData),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response && response.error) {
        let errorMessage = 'Error al actualizar usuario';
        if (response.errorMsg) {
          try {
            const parsedError = JSON.parse(response.errorMsg);
            errorMessage = parsedError.error || parsedError.details || errorMessage;
          } catch (e) {
            errorMessage = response.errorMsg;
          }
        }

        yield put(apiSuccess(USERS.UPDATE_USER_FAIL, { error: errorMessage }));
        yield put(appActions.setError(errorMessage));
        return;
      }

      if (response && response.user) {
        const updatedUser = {
          ...response.user,
          role: response.user.role || null,
        };

        const transformedPayload = {
          objects: {
            users: {
              [response.user.id]: updatedUser,
            },
          },
          user: updatedUser,
          message: response.message,
        };

        yield put(apiSuccess(USERS.UPDATE_USER_SUCCESS, transformedPayload));
        yield put(appActions.setSuccess('Usuario actualizado exitosamente'));
      } else {
        yield put(
          apiSuccess(USERS.UPDATE_USER_FAIL, { error: 'Respuesta incompleta del servidor' }),
        );
      }
    } catch (error) {
      let errorMessage = 'Error al actualizar usuario';
      if (error.response && error.response.data) {
        errorMessage = error.response.data.error || error.response.data.message || errorMessage;
      } else if (error.message) {
        errorMessage = error.message;
      }
      yield put(apiSuccess(USERS.UPDATE_USER_FAIL, { error: errorMessage }));
      yield put(appActions.setError(errorMessage));
    }
  });
}

function* deleteUser() {
  yield takeLatest(USERS.DELETE_USER, function* (action) {
    try {
      const { userId } = action;
      const response = yield apiRequest(`api/v1/users/${userId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response && response.message) {
        const transformedPayload = {
          type: 'users',
          item: { id: userId },
          message: response.message,
        };

        yield put(apiSuccess(USERS.DELETE_USER_SUCCESS, transformedPayload));
        yield put(appActions.setSuccess('Usuario eliminado exitosamente'));
      } else {
        yield put(
          apiSuccess(USERS.DELETE_USER_FAIL, { error: 'Respuesta incompleta del servidor' }),
        );
      }
    } catch (error) {
      console.error('Error en deleteUser saga:', error);
      let errorMessage = 'Error al eliminar usuario';
      if (error.response && error.response.data) {
        errorMessage = error.response.data.error || error.response.data.message || errorMessage;
      } else if (error.message) {
        errorMessage = error.message;
      }
      yield put(apiSuccess(USERS.DELETE_USER_FAIL, { error: errorMessage }));
      yield put(appActions.setError(errorMessage));
    }
  });
}
export default function* saga() {
  yield spawn(getStateFromApi);
  yield spawn(createUser);
  yield spawn(updateUser);
  yield spawn(deleteUser);
}
